import { catalogueRequest } from 'location/locality'
import _ from 'lodash'
import type { GetServerSidePropsContext } from 'next'

import { pagesDataAPI } from '../../axios/axios'
import Map from './Map'

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const request = catalogueRequest(context)
  if (request.redirect) return { redirect: request.redirect }
  const query = request.params
  let data: any = []
  const queryParams = _.omit(query, 'type')
  try {
    if (query.type === 'programs') {
      const res = await pagesDataAPI.getProgramsForMap(queryParams)
      data = res.data ?? null
    }
    if (query.type === 'events') {
      const res = await pagesDataAPI.getEventsForMap(queryParams)
      data = res.data ?? null
    }
    if (query.type === 'organizations') {
      const res = await pagesDataAPI.getUnitsForMap(queryParams)
      data = res.data ?? null
    }
    return {
      props: {
        mapData: data,
      },
    }
  } catch (e) {
    return {
      props: {
        mapData: [],
      },
    }
  }
}

export default Map
